/**
 * Catalogue Marocain des Déchets code helpers (décret 2-07-253).
 * A code is written as three pairs of digits separated by single spaces ("08 01 11");
 * chapters have one pair ("08") and sub-chapters two ("08 01").
 */
const CODE_RE = /^\d{2}( \d{2}){0,2}$/;
/** Normalises "080111", "08-01-11", "08 01 11 " or "08.01.11" into "08 01 11". Throws on invalid input. */
export function normalizeCmdCode(input) {
    const digits = input.replace(/[^0-9]/g, '');
    if (digits.length !== 2 && digits.length !== 4 && digits.length !== 6) {
        throw new Error(`Invalid CMD code: "${input}"`);
    }
    return digits.match(/.{2}/g).join(' ');
}
export function isValidCmdCode(code) {
    return CODE_RE.test(code);
}
export function cmdLevel(code) {
    if (!isValidCmdCode(code))
        throw new Error(`Invalid CMD code: "${code}"`);
    return code.split(' ').length;
}
export function cmdParent(code) {
    const parts = code.split(' ');
    return parts.length > 1 ? parts.slice(0, -1).join(' ') : null;
}
export function cmdChapter(code) {
    return code.split(' ')[0];
}
/** Entries ending in 99 are "déchets non spécifiés ailleurs" and need a description (BR-02). */
export function isNotSpecifiedElsewhere(code) {
    return cmdLevel(code) === 3 && code.endsWith(' 99');
}
/** Six-digit form without spaces, as printed on labels ("080111"). */
export function cmdCompact(code) {
    return code.replace(/ /g, '');
}
//# sourceMappingURL=cmd.js.map